<template>
	<a
		ref="postLink"
		v-if="url"
		:href="url"
		class="dc-button dc-button--has-icon dc-button--color-orange"
		:aria-label="aria_label"
	>
		<span class="icon icon-arrow-right"></span>
	</a>
</template>

<script>
export default {
	props: {
		url: {
			type: String,
			required: true,
		},
		aria_label: {
			type: String,
			required: true,
		},
	},
};
</script>
